import React from 'react'
import Header from '../header/Header'
import RefractSalepage from '../salepage/RefractSalepage'
import '../salepage/refractsalepage.css'

const Refract = () => {
    return (
        <div className="refract-page-wrapper">
            <Header />
            <RefractSalepage />
        </div>
    )
}

export default Refract
